const regexp = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;

export default function(hint: string): [number, number] | null {
  if (regexp.test(hint)) {
    let coords = hint.replace(' ', '').split(',');
    return [parseFloat(coords[0]), parseFloat(coords[1])];
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/matchCoordinatesFormat.ts